/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SECOfficeEnum = {
    SecNewYork: 'SEC_NEW_YORK',
    SecLosAngeles: 'SEC_LOS_ANGELES',
    SecBoston: 'SEC_BOSTON',
    SecChicago: 'SEC_CHICAGO',
    SecMiami: 'SEC_MIAMI',
    SecMarketAbuseUnit: 'SEC_MARKET_ABUSE_UNIT',
    SecAtlanta: 'SEC_ATLANTA',
    SecDenver: 'SEC_DENVER',
    SecFortWorth: 'SEC_FORT_WORTH',
    SecPhiladelphia: 'SEC_PHILADELPHIA',
    SecSanFrancisco: 'SEC_SAN_FRANCISCO'
} as const;
export type SECOfficeEnum = typeof SECOfficeEnum[keyof typeof SECOfficeEnum];


export function instanceOfSECOfficeEnum(value: any): boolean {
    for (const key in SECOfficeEnum) {
        if (Object.prototype.hasOwnProperty.call(SECOfficeEnum, key)) {
            if (SECOfficeEnum[key as keyof typeof SECOfficeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SECOfficeEnumFromJSON(json: any): SECOfficeEnum {
    return SECOfficeEnumFromJSONTyped(json, false);
}

export function SECOfficeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SECOfficeEnum {
    return json as SECOfficeEnum;
}

export function SECOfficeEnumToJSON(value?: SECOfficeEnum | null): any {
    return value as any;
}

export function SECOfficeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): SECOfficeEnum {
    return value as SECOfficeEnum;
}

